import { OrderSigns } from '../constants';

export function getOrderSign(order) {
    return order ? OrderSigns[order] : order;
}
